import Vue from 'vue';
import VueRouter from 'vue-router';
import searchVue from '@/views/search/index.vue'
import searchHeadVue from '@/views/search/head.vue'

import indexHead from '../views/index/head.vue';
import indexPage from '../views/index/index.vue';
import detailInfoPage from '../views/detailInfo/index.vue';
import poorInfoPage from '../views/poorInfo/index.vue';
import weatherInfoPage from '../views/weatherInfo/index.vue';
import mapPage from '../views/map/index.vue';
import iframePage from '../views/iframe/index.vue';
import packPage from '../views/pack/index.vue';

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'search',
      components: {
        default: searchVue,
        head: searchHeadVue
      }
    },
    {
      path: '/index',
      name: 'index',
      components: {
        default: indexPage,
        head: indexHead
      }
    },
    {
      path: '/pack',
      name: 'pack',
      components: {
        default: packPage,
        head: indexHead
      }
    },
    {
      path: '/detailInfo',
      name: 'detailInfo',
      components: {
        default: detailInfoPage,
        head: indexHead
      }
    },
    {
      path: '/poorInfo',
      name: 'poorInfo',
      components: {
        default: poorInfoPage,
        head: indexHead
      }
    },
    {
      path: '/weatherInfo',
      name: 'weatherInfo',
      components: {
        default: weatherInfoPage,
        head: indexHead
      }
    },
    {
      path: '/map',
      name: 'map',
      components: {
        default: mapPage,
        head: indexHead
      }
    },
    {
      path: '/iframe',
      name: '/iframe',
      components: {
        default: iframePage,
        head: indexHead
      }
    }
  ]
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js